const DoctorLogin = () => {

    return (
        <>
            <h1>Doctor Login Page</h1>
        </>
    )

}

export default DoctorLogin;